module.exports = __webpack_public_path__ + "img/Roy-castle.351ec692.jpg";